export class DatosTratamientoCita {

    idTratamiento;
    rango;
    visible;
    respuestaVariante;

    constructor() {
        this.visible = true;
    }
}